exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".statusContainer {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 10px;\n  text-transform: uppercase;\n  border-radius: 50px;\n}", ""]);

// exports
